export const ORG_ROLES = ["ORG_ADMIN", "PORTFOLIO_LEAD", "MEMBER", "ACCOUNTS", "PROCUREMENT", "STORES", "HR"];
export const ERP_APPROVER_ROLES = ["ORG_ADMIN", "PORTFOLIO_LEAD", "ACCOUNTS", "PROCUREMENT", "STORES", "HR"];
export const RESET_FREQUENCIES = ["NEVER", "MONTHLY", "YEARLY"];
export const PROJECT_ROLES = ["PROJECT_MANAGER", "ENGINEERING", "PROCUREMENT", "SITE", "VIEWER"];
export const PROJECT_STATUSES = ["PLANNING", "ACTIVE", "ON_HOLD", "COMMISSIONED", "CLOSED"];
export const DOC_STATUSES = [
  "NOT_STARTED", "UNDER_EPC", "UNDER_OE", "SUBMITTED", "SUB_APPROVED",
  "APPROVED", "NOTED_FOR_INFORMATION", "OPTIONAL", "VOID",
];
export const ISSUE_PRIORITIES = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];
export const ISSUE_STATUSES = ["OPEN", "IN_PROGRESS", "BLOCKED", "CLOSED"];
export const TASK_STATUSES = ["NOT_STARTED", "IN_PROGRESS", "COMPLETED", "DELAYED"];
export const ALERT_STATUSES = ["OPEN", "ACKNOWLEDGED", "RESOLVED"];

const CATEGORY_WRITE_ROLES = {
  ENGINEERING: ["PROJECT_MANAGER", "ENGINEERING", "SITE"],
  PROCUREMENT: ["PROJECT_MANAGER", "PROCUREMENT"],
  CONSTRUCTION: ["PROJECT_MANAGER", "SITE"],
};

export function canWriteCategory(projectRole, category) {
  return CATEGORY_WRITE_ROLES[category]?.includes(projectRole) ?? false;
}
